import { render, staticRenderFns } from "./DangerRestaurant.vue?vue&type=template&id=31d9ec77&"
import script from "./DangerRestaurant.vue?vue&type=script&lang=js&"
export * from "./DangerRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./DangerRestaurant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports